// src/component/IssueCertificatePage.js
import React, { useState, useEffect } from "react";
import { Card, Typography, Form, Select, Button, message, Space } from "antd";
import { FileProtectOutlined } from "@ant-design/icons";
import axios from "axios";
import Cookies from "universal-cookie";

const { Title, Paragraph } = Typography;

const IssueCertificatePage = () => {
    const cookies = new Cookies();
    const auth = cookies.get("authToken");
    const config = { headers: { "auth-token": auth } };

    const [form] = Form.useForm();
    const [students, setStudents] = useState([]);
    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const [studentRes, courseRes] = await Promise.all([
                    axios.post("/api/user/getUsers", { role: "student" }, config),
                    axios.get("/api/courses/teacher", config),
                ]);
                setStudents(studentRes.data.filter((u) => u.is_delete === 0));
                setCourses(courseRes.data);
            } catch (error) {
                message.error("โหลดข้อมูลผู้เรียน/คอร์สไม่สำเร็จ");
            }
            setLoading(false);
        };
        fetchData();
    }, []);

    const onFinish = async (values) => {
        setSubmitting(true);
        try {
            const res = await axios.post("/api/exam/issue-certificate", values, config);
            message.success(`ออกใบประกาศสำเร็จ (เลขที่ ${res.data.certificateNumber})`);
            form.resetFields();
        } catch (error) {
            if (error.response?.status === 409) {
                message.warning("ผู้เรียนคนนี้มีใบประกาศของคอร์สนี้อยู่แล้ว");
            } else {
                message.error(error.response?.data?.message || "ออกใบประกาศไม่สำเร็จ");
            }
        }
        setSubmitting(false);
    };

    return (
        <Card style={{ maxWidth: 600, margin: "24px auto" }}>
            <Space direction="vertical" size="small" style={{ width: "100%" }}>
                <Title level={3}>
                    <FileProtectOutlined /> ออกใบประกาศ
                </Title>
                <Paragraph type="secondary">เลือกผู้เรียนและคอร์สเพื่อออกใบประกาศนียบัตรให้</Paragraph>
                <Form form={form} layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        name="userId"
                        label="ผู้เรียน"
                        rules={[{ required: true, message: "กรุณาเลือกผู้เรียน" }]}
                    >
                        <Select
                            showSearch
                            loading={loading}
                            placeholder="เลือกผู้เรียน"
                            optionFilterProp="label"
                            options={students.map((u) => ({
                                value: u.id,
                                label: `${u.name_prefix || ""} ${u.firstname} ${u.lastname}`.trim(),
                            }))}
                        />
                    </Form.Item>
                    <Form.Item
                        name="courseId"
                        label="คอร์ส"
                        rules={[{ required: true, message: "กรุณาเลือกคอร์ส" }]}
                    >
                        <Select
                            showSearch
                            loading={loading}
                            placeholder="เลือกคอร์ส"
                            optionFilterProp="label"
                            options={courses.map((c) => ({ value: c.id, label: c.title }))}
                        />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" loading={submitting} block>
                            ออกใบประกาศ
                        </Button>
                    </Form.Item>
                </Form>
            </Space>
        </Card>
    );
};

export default IssueCertificatePage;
